import React from "react";
import PropTypes from 'prop-types';
const pageTilte = (props) => {
    return (


        <section className="page-title">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <h2>{props.title}</h2>
                        <ol className="breadcrumb">
                            <li><a href="/">صفحه اصلی</a></li>
                            <li>{props.title}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>


    );
};

pageTilte.propTypes = {

    title: PropTypes.string.isRequired,
};

export default pageTilte; 